export default "__VITE_ASSET__BM4TJl$D__"